// @ts-nocheck
import Service from './Service';
import _ from 'lodash';
import { getPureTextApi } from 'library-@/apis/core_basic_api/patent';
import { transformByHtmlInnerText } from '../utils';
import { RequestChannel } from '@patsnap/common-ps-http';
import workerText from 'raw-loader!../lib/DiffMatchPatch.js';
import { LINK_BREAK, MAX_WORD_NUM } from '@/constants';
import { translateByPatsnap } from '@/lib/api/translates';
import { transformByHtmlTextSplitList } from '@/utils';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import {
    GetComparePatentText,
} from '@/infrastructure/api-functions/core-search-api/core-search-api';

function createWorker() {
    const workerBlob = new Blob([workerText], {
        type: 'application/javascript',
    });

    const blobUrl = window.URL.createObjectURL(workerBlob);
    const worker = new Worker(blobUrl);
    window.URL.revokeObjectURL(blobUrl);
    return worker;
}

export default class CompareService extends Service {
    constructor(patentId) {
        super();
        this.patentId = patentId;
        this.lang = 'en';
        this.worker = undefined;
    }

    startWorker() {
        this.worker = new createWorker();
        return this.worker;
    }

    async getPureText(type, lang) {
        const resp = await RequestChannel.toPromise(
            // 可单独提取作为一个公用方法。
            getPureTextApi({ patentId: this.patentId, type: type, lang }),
            subscription => this.subscriptions.add(subscription),
        );
        const arr = _.get(resp, `data.${type}Arr`, []);
        const relatedPatentId = _.get(resp, 'data.relatedPatent.patent_id', '');
        this.lang = (_.get(resp, 'data.lang', 'en')).toLowerCase();

        const str = arr.map(function(str) {
            return transformByHtmlInnerText(str);
        }).join(LINK_BREAK);

        return { str, relatedPatentId };
    }

    async getTransText(type, lang) {
        const params = {
            original: false,
            section: type.toUpperCase(),
            patentId: this.patentId,
            lang,
        };
        const transResult = await translateByPatsnap(params)
            .then(r => r || '');
        this.lang = lang;
        const str = transformByHtmlTextSplitList(transResult).join(LINK_BREAK);
        return { str };
    }

    async getComparePatentText({ type, lang, compareId }) {
        const service = injectService<GetComparePatentText>(GetComparePatentText);
        const data = await service.getComparePatentText({
            compare_id: compareId,
            patent_id: this.patentId,
            lang: lang,
            field_type: type,
        });
        return {
            str: transformByHtmlTextSplitList(data[type]).join(LINK_BREAK),
        };
    }

    // https://confluence.zhihuiya.com/display/doc/Claims+compare+tool
    genCompareDom(aText, bText, lang, pattern) {
        if (this.worker) {
            this.worker.terminate();
            this.worker = undefined;
        }
        this.startWorker();

        function getWordNum(str) {
            return str.split(' ').length;
        }

        // eslint-disable-next-line no-unused-vars
        return new Promise((resolve, reject) => {
            const worker = this.worker;

            let type = ['cn', 'jp', 'kr'].includes(lang) ? 'char' : 'word';

            // 超长文本用word太卡
            if (type === 'word' && (getWordNum(aText) > MAX_WORD_NUM || getWordNum(bText) > MAX_WORD_NUM)) {
                type = 'char';
            }

            worker.postMessage({
                type,
                aText,
                bText,
            });

            worker.onerror = reject;

            worker.addEventListener('message', function(e) {
                const d = e.data;

                let totalDiffCount = 0;

                const fragment = document.createDocumentFragment();

                const getType = num => (num === 1 ? 'added' : num === -1 ? 'removed' : 'same');

                d.forEach((part) => {
                    let diffCode = part[0];
                    const value = part[1];
                    if (value === LINK_BREAK || _.trim(value) === '') {
                        diffCode = 0;
                    }

                    // green for additions, red for deletions
                    // grey for common parts
                    const type = getType(diffCode);
                    if (type === 'added' || type === 'removed') {
                        totalDiffCount += 1;
                    }
                    // 控制只显示added 或 removed的文本
                    if (type !== 'same' && (pattern && pattern !== type)) return;

                    const span = document.createElement('span');
                    span.classList.add(`c-${type}`);
                    span.appendChild(document.createTextNode(value));
                    fragment.appendChild(span);
                });

                resolve({ fragment, totalDiffCount });

            }, false);
        });
    }

    destroy() {
        super.destroy();
        if (this.worker) {
            this.worker.terminate();
            this.worker = undefined;
        }
    }
}
